module.exports = __webpack_public_path__ + "static/media/bancolombia-ico-editar-hv.6d538fbe.svg";